// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__zqadI","list":"styles_list__1NLPn"};